/**
 * @prettier
 * @flow
 */
export function transformStringOutput(value?: ?string): ?string {
    return !value ? null : value;
}
